import React, { useContext, useEffect, useState, useCallback } from "react";
import { LegacyCard as Card, Tag, ChoiceList } from "@shopify/polaris";
import { useQuery } from "@apollo/client";

import { withErrorBoundary } from "lib/hoc";

//  import helpers
import baseHelper from "lib/helpers/base";
import { errorHelper } from "lib/helpers";

//  import constant
import constant from "lib/constant/constant";

//  import helpers component
import { ResourceList } from "lib/components";

//  import filter component
import MoreFilters from "app/paymentsLake/modules/generic/moreFilters/moreFilter";

//  import context
import { PrivateContext } from "lib/context";

// import gql
import { GET_PAYMENT_LAKE_LIST } from "app/paymentsLake/apollo/queries";
import PAYMENT_LAKE_LIST from "app/payments/apollo/subscriptions/payments";

//  import cms
import actionData from "app/paymentsLake/modules/operator/features/list/cms/resourceTableData";

//  import subFeature
import { listProp } from "app/paymentsLake/modules/operator/features/list/propTypes";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import QueryString from "query-string";
import PaymentRow from "./paymentRow";

const PaymentList = (props) => {
  const { setBanner } = props;
  const { cms } = useContext(PrivateContext);
  const location = useLocation();
  const navigate = useNavigate();
  const { ALL, CREATED_AT, DESC, FILTER_BY, gql, PAID, TAGGED_WITH } = constant;
  const [searchParams] = useSearchParams();
  const queryParam = QueryString.parse(searchParams.toString());
  // const [loading, setLoading] = useState(true);
  const [taggedWith, setTaggedWith] = useState(queryParam.list_search || "");
  const [selectedFilter, setSelectedFilter] = useState(queryParam.list_filter || "");
  const paramFilter = (queryParam.filter && queryParam.filter.split(",")) || "";
  const [filterByStatus, setFilterByStatus] = useState(paramFilter || "");
  const [paymentListData, setPaymentList] = useState([]);
  const [paymentCount, setPaymentCount] = useState(0);
  const resourceData = actionData(cms);
  // const [selectedItems, setSelectedItems] = useState([]);
  const [perPage, setPerPage] = useState(parseInt(queryParam.perPage, 10) || 10);
  const [page, setPage] = useState(parseInt(queryParam.page, 10) || 1);
  const [search, setSearch] = useState(queryParam.search || "");
  const [sortValue, setSortValue] = useState(constant.CREATED_DESC);
  // const [tab, setTab] = useState(parseInt(queryParam.tab, 10) || 0);
  const [activePopover, setActivePopover] = useState({});

  // const [popoverActive, setPopoverActive] = useState(false);
  //  eslint-disable-next-line no-shadow
  // const togglePopoverActive = useCallback(() => setPopoverActive((popoverActive) => !popoverActive), []);

  if (selectedFilter === constant.NAME) {
    setSelectedFilter(constant.PRODUCT_NAME);
  }
  const renderItem = (item) => {
    return (
      <PaymentRow item={item} setBanner={setBanner} activePopover={activePopover} setActivePopover={setActivePopover} />
    );
  };
  const inputData = {
    filter: filterByStatus,
    path: queryParam.path,
    sort_name: queryParam.sort_name || CREATED_AT,
    sort_order: queryParam.sort_order || DESC,
    sort_date: queryParam.sort_date,
    page: parseInt(queryParam.page, 10),
    perPage: parseInt(perPage, 10),
    list_search: queryParam.list_search,
    list_filter: queryParam.list_filter,
    search: queryParam.search,
  };
  const { data: orderLinesData, loading: orderLoading, error, subscribeToMore, refetch } = useQuery(
    GET_PAYMENT_LAKE_LIST,
    {
      variables: {
        input: inputData,
      },
      notifyOnNetworkStatusChange: true,
    }
  );
  // useEffect(() => {
  // setSelectedItems([]);
  // if (!orderLoading) {
  // setLoading(false);
  //   }
  // }, [orderLoading]);

  useEffect(() => {
    if (error) {
      setBanner({ isOpen: true, title: errorHelper.parse(error), status: constant.CRITICAL });
    }
  }, [error, setBanner]);

  const orderLineError = baseHelper.getResponseError(orderLinesData, gql.GET_PAYMENT_LAKE_LIST);
  useEffect(() => {
    if (orderLineError) {
      setBanner({ isOpen: true, status: constant.CRITICAL, title: orderLineError });
    }
  }, [orderLineError, setBanner]);

  useEffect(() => {
    subscribeToMore({
      document: PAYMENT_LAKE_LIST,
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) return prev;
        return refetch();
      },
    });
  }, [subscribeToMore, refetch]);

  const responseOrderLinesData = baseHelper.getResponseData(orderLinesData, gql.GET_PAYMENT_LAKE_LIST);

  useEffect(() => {
    if (responseOrderLinesData) {
      setPaymentList(responseOrderLinesData && responseOrderLinesData.paymentList);
      setPaymentCount(responseOrderLinesData && responseOrderLinesData.count);
    }
  }, [responseOrderLinesData]);

  // const handleSelect = (item) => {
  //   setSelectedItems(item);
  // };

  useEffect(() => {
    if (filterByStatus && filterByStatus.length) {
      baseHelper.setUrl(location, navigate, { filter: filterByStatus, page: 1 });
    } else baseHelper.setUrl(location, navigate, { filter: "", page: 1 });
  }, [filterByStatus]);

  const removeTag = useCallback(
    (tag) => () => {
      setFilterByStatus((previousTags) => previousTags.filter((previousTag) => previousTag !== tag));
    },
    []
  );

  // const handleTabChange = (tabSelected) => {
  //   setTab(parseInt(tabSelected, 10));
  //   setSelectedItems([]);
  //   if (resourceData.tabsData && resourceData.tabsData[tabSelected] && resourceData.tabsData[tabSelected].id) {
  //     baseHelper.setUrl(location, navigate, {
  //       tab: tabSelected,
  //       filter: resourceData.tabsData[tabSelected].id,
  //       page: 1,
  //     });
  //     setFilterByStatus([resourceData.tabsData[tabSelected].id]);
  //     setPage(1);
  //   }
  // };

  const handleSearchChange = (searchValue) => {
    setSearch(searchValue);
    baseHelper.setUrl(location, navigate, { search: searchValue, page: 1 });
  };
  const handlePageLimitChange = (value) => {
    setPerPage(value);
    baseHelper.setUrl(location, navigate, { perPage: value, page: 1 });
  };
  const handlePageChange = (value) => {
    setPage(value);
    baseHelper.setUrl(location, navigate, { page: value });
  };
  const handleSort = (selected) => {
    setSortValue(selected);
    const sort = selected.split("_");
    if (sort && sort.length === 2) {
      baseHelper.setUrl(location, navigate, { sort_name: sort[0], sort_order: sort[1] });
    }
  };
  const handleQueryClear = () => {
    setSearch(null);
    baseHelper.setUrl(location, navigate, { search: "" });
  };
  // const bulkActions = [
  // {
  //   content: cms("label.payPaypal"),
  //   onAction: () => handleBulkAccount(PAIDVIAPAYPAL),
  // },
  // {
  //   content: cms("label.payStripe"),
  //   onAction: () => handleBulkAccount(PAIDVIASTRIPE),
  // },
  // {
  //   content: cms("label.markDispute"),
  //   onAction: () => handleBulkAccount(DISPUTE),
  // },
  // ];
  const handleTaggedWithRemove = (clearFilter = false, key) => {
    const clearParams =
      key === constant.FILTER_BY_STATUS ? { filter: "", page: 1 } : { list_search: "", list_filter: "", page: 1 };
    if (clearFilter) {
      if (key) {
        switch (key) {
          case constant.TAGGED_WITH:
            return [setTaggedWith(""), setSelectedFilter(""), baseHelper.setUrl(location, navigate, clearParams)];
          case constant.FILTER_BY_STATUS:
            return [setFilterByStatus(null), baseHelper.setUrl(location, navigate, clearParams)];
          default:
            return null;
        }
      }
    }
    clearParams.list_filter = "";
    clearParams.filter = "";
    setTaggedWith("");
    setSelectedFilter("");
    setFilterByStatus(null);
    baseHelper.setUrl(location, navigate, clearParams);
    return null;
  };

  const handleClearAll = () => {
    handleTaggedWithRemove(false);
    handleQueryClear();
  };

  let tagMarkup = [];
  if (filterByStatus && filterByStatus.length) {
    tagMarkup =
      filterByStatus &&
      filterByStatus.map((option) => (
        <Tag key={option} onRemove={removeTag(option)}>
          {baseHelper.ucFirst(option)}
        </Tag>
      ));
  }

  const disambiguateLabel = (key, value) => {
    switch (key) {
      case constant.TAGGED_WITH:
        return `${value}`;
      case constant.SELECTED_FILTER:
        return cms(`label.${value}`) || value;
      case constant.FILTER_BY_STATUS:
        return <div className="remove_tag">{tagMarkup}</div>;
      default:
        return value;
    }
  };

  const isEmpty = (value) => {
    if (Array.isArray(value)) {
      return value.length === 0;
    }
    return value === "" || value == null;
  };

  const appliedFilterArrObj = [];
  if (!isEmpty(taggedWith)) {
    appliedFilterArrObj.push({
      key: constant.TAGGED_WITH,
      label: disambiguateLabel(constant.TAGGED_WITH, taggedWith),
      onRemove: () => handleTaggedWithRemove(true, constant.TAGGED_WITH),
    });
  }

  if (!isEmpty(selectedFilter)) {
    appliedFilterArrObj.push({
      key: constant.SELECTED_FILTER,
      label: disambiguateLabel(constant.SELECTED_FILTER, selectedFilter),
      onRemove: () => handleTaggedWithRemove(false),
    });
  }

  if (!isEmpty(filterByStatus)) {
    appliedFilterArrObj.push({
      key: constant.FILTER_BY_STATUS,
      label: disambiguateLabel(constant.FILTER_BY_STATUS, filterByStatus),
      onRemove: () => handleTaggedWithRemove(true, constant.FILTER_BY_STATUS),
    });
  }
  const appliedFilters = appliedFilterArrObj;
  // const appliedFilters = [];
  // const filterOptions = [{ label: cms("label.brandName"), value: constant.VENDOR }];
  const filterOptions = [{ label: constant.PRODUCT_NAME, value: constant.NAME }];

  const filterByStatusOption = [
    {
      label: cms("label.all"),
      value: ALL,
    },
    // {
    //   label: cms("label.duePayment"),
    //   value: DUE,
    // },
    {
      label: cms("label.pay"),
      value: PAID,
    },
  ];

  const handleAction = (value) => {
    setFilterByStatus(value);
    baseHelper.setUrl(location, navigate, { filter: value, page: 1 });
    if (!value.length) {
      baseHelper.setUrl(location, navigate, { filter: "all", page: 1 });
    }
  };

  // const activator = (
  //   <Button fullWidth onClick={togglePopoverActive} disclosure>
  //     Status
  //   </Button>
  // );

  const filters = [
    {
      key: TAGGED_WITH,
      // label: cms("label.filter"),
      label: FILTER_BY,
      filter: (
        <MoreFilters
          taggedWith={taggedWith}
          setTaggedWith={setTaggedWith}
          selectedFilter={selectedFilter}
          setSelectedFilter={setSelectedFilter}
          filterOptions={filterOptions}
        />
      ),
    },
    {
      key: constant.FILTER_BY_STATUS,
      label: "Filter by status",
      filter: (
        <>
          {/* <Popover active={popoverActive} activator={activator} onClose={togglePopoverActive}>
            <OptionList
              fullWidth
              allowMultiple
              onChange={(value) => handleAction(value)}
              options={filterByStatusOption}
              selected={filterByStatus || []}
            />
          </Popover> */}
          <ChoiceList
            title="Filter by status"
            titleHidden
            choices={filterByStatusOption}
            selected={filterByStatus || []}
            onChange={(value) => handleAction(value)}
            allowMultiple
          />
        </>
      ),
    },
  ];
  return (
    <Card>
      {/* <Tabs tabs={resourceData.tabsData} selected={tab} onSelect={handleTabChange} /> */}
      <ResourceList
        items={paymentListData}
        idForItem={(orderLine) => {
          const { _id: id } = orderLine;
          return id;
        }}
        renderItem={renderItem}
        loading={orderLoading}
        queryValue={search}
        onQueryClear={handleQueryClear}
        onQueryChange={handleSearchChange}
        sortOptions={resourceData.sortOptions}
        sortValue={sortValue}
        onSortChange={handleSort}
        // selectedItems={selectedItems}
        // onSelectionChange={handleSelect}
        // bulkActions={bulkActions}
        filters={filters}
        appliedFilters={appliedFilters}
        handleClearAll={handleClearAll}
        // selectable
        count={paymentCount}
        page={page}
        perPage={perPage}
        setPage={handlePageChange}
        setPerPage={handlePageLimitChange}
      />
    </Card>
  );
};

PaymentList.propTypes = listProp.type;

export default withErrorBoundary(PaymentList);
